module.exports = __webpack_public_path__ + "img/favorite-add.42c31979.svg";